import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const PersonalSituation = () => {
  return (
    <>
      <Box paddingTop="s24" paddingBottom="s8">
        <Text.Normal size="300" color="grey800" weight="medium">
          {i18n.t(
            'processes.process_settings.wizard.tasks.types.request_general_information.preview.personal_situation.title'
          )}
        </Text.Normal>
      </Box>

      <Box padding="s24" gap="s24" background="grey200" borderRadius={{ all: 'abs008' }}>
        <Box width="full" gap="s4">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {i18n.t('employee_form.personal_situation.form.disability_percentage')}
          </Text.Normal>
          <Box
            background="grey000White"
            padding="s16"
            borderRadius={{ all: 'abs008' }}
            flexDirection="row"
            justifyContent="spaceBetween"
            alignItems="center"
            border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
          >
            <Text.Normal color="grey600">
              {i18n.t('add_employee_modal.fields.percentage_placeholder')}
            </Text.Normal>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default PersonalSituation
